<div *ngIf="!isReady">
  <div class="spinner">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
    <p>Loading...</p>
  </div>
</div>
